import React from 'react';
import {Button, Checkbox, Form, Icon, Modal, Select, Tooltip} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import QrReader from 'react-qr-reader';
import {fetchRelationshipSearch, fetchRelationshipSearchData,} from '../../appRedux/actions/Common';
import MasterModal from "../MasterModal";
import SuperMasterModal from "../SuperMasterModal";
import {saveSpareNameInSpareIssues} from "../../appRedux/actions";
import {createDebounce} from "../../util/methods";

class FieldSearchForm extends React.Component {
  state = {
    value: '',
    selectedRecord: {},
    openCamera: false,
    manualAssetSelect: false,
  };

  getEffectiveSearchData = (props = this.props) => {
    if (Array.isArray(props.searchDataOverride)) {
      return props.searchDataOverride;
    }
    return props.searchData || [];
  };

  componentDidMount() {
    if(this.props.options && this.props.options.qr_scan) {
      const {qr_scan: isQr} = this.props.options;
      this.setState({manualAssetSelect: !isQr || true})
    } else {
      this.setState({manualAssetSelect: true})
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextSearchData = this.getEffectiveSearchData(nextProps);
    const currentSearchData = this.getEffectiveSearchData(this.props);
    if(nextProps && nextSearchData && nextSearchData.length > 0 && JSON.stringify(nextSearchData) !== JSON.stringify(currentSearchData)) {
      if(!this.state.manualAssetSelect) {
        const searchData = nextSearchData;
        if(searchData && searchData.length > 0) {
          const data = {};
          data[this.props.name] = searchData[0]._id;
          this.props.setFieldsValue(data);
        }
      }
    }

  }

  openCamera = () => {
    this.setState({openCamera: !this.state.openCamera})
  };
  toggleManual = (e) => {
    const checked = e.target.checked;
    this.setState({manualAssetSelect: checked});
    if(checked) {
      const data = {};
      data[this.props.name] = '';
      // this.props.setFieldsValue(data);
    }
  }

  handleScan = async data => {
    if(this.props.name === 'asset') {
      if(data && data.includes('assetCode=')) {
        const assetCode = data.split('assetCode=').pop().split('&')[0];
        const {field, model} = this.props;
        this.props.fetchRelationshipSearchData(assetCode, model, field);
        this.setState({openCamera: false, value: assetCode});
      }
    }
  };

  handleScanError = err => {
    console.error(err)
  };

  debouncedSearch = createDebounce((searchValue) => {
    // Perform your backend search request here with the searchValue
    console.log('Searching for:', searchValue);
    const {field, model, customSearch} = this.props;
    if(customSearch) {
      customSearch(searchValue);
      return;
    }
    this.props.fetchRelationshipSearchData(searchValue, model, field);
  }, 400); // Adjust the delay (in milliseconds) as needed

  handleSearch = value => {
    const defaultMinSearchLength = this.props.model === 'SparePart' ? 2 : 4;
    const minSearchLength = Number.isFinite(Number(this.props.minSearchLength))
      ? Number(this.props.minSearchLength)
      : defaultMinSearchLength;
    this.setState({ value });
    if(value && value.length >= minSearchLength) {
      this.debouncedSearch(value);
      return;
    }
    if(this.props.customSearch) {
      this.props.customSearch('');
    } else {
      this.props.fetchRelationshipSearch();
    }
  };

  handleChange = value => {
    const searchData = this.getEffectiveSearchData();
    if(this.props.onChange) {
      this.props.onChange(value);
    }
    this.setState({
      selectedRecord: searchData.filter(item => item._id === value)[0]
    }, () => {
      if(this.props.name === 'spareName') {
        this.props.saveSpareNameInSpareIssues(this.state.selectedRecord);
      }
    });

    const field = {};
    field[this.props.name] = value;
    this.props.setFieldsValue(field);

    setTimeout(() => {
      this.props.fetchRelationshipSearch();
    }, 200);
  };

  render() {
    const {
      name, label, message, required, field, model, placeholder, initialValue, showArrow,
      searchData, getFieldDecorator, disabled, title, otherDetails, options, excludedIds = []
    } = this.props;
    const effectiveSearchData = this.getEffectiveSearchData();

    // Filter out already selected spare parts to prevent duplicates
    const filteredSearchData = effectiveSearchData
      ? effectiveSearchData.filter(item => !excludedIds.includes(item._id))
      : [];
    return (
      <Form.Item key={name}
                 label={
                   <span>{label}&nbsp;
                     {options && options.description ?
                       (<Tooltip title={options.description}>
                         <Icon type="question-circle-o"/>
                       </Tooltip>) : null}
                          </span>
                 }
                 style={(options && (otherDetails && (otherDetails.resource !== 'ThirdPartyWorkQuotation' && otherDetails.resource !== 'InvoiceEntry')) && (options.master || options.superMaster))
                   ? {width: '80%', marginTop: '-10px'}
                   : {width: '100%'}}
      >
        {getFieldDecorator(name, {
          rules: [{required: required, message: message}],
          initialValue: this.state.value ? null : initialValue ? initialValue._id : '',
        })(<Select
          placeholder={placeholder || "Please select"}
          disabled={disabled ? disabled : this.props && this.props.disableAll || !this.state.manualAssetSelect}
          showArrow={showArrow}
          showSearch
          allowClears
          style={(options && (options.master || options.superMaster)) ? {
            width: '80%',
            marginTop: '-10px'
          } : {width: '100%'}}
          filterOption={false}
          notFoundContent={null}
          onSelect={this.props.onSelect || (() => {
          })}
          onSearch={this.handleSearch}
          onChange={this.handleChange}
        >
          {!this.state.value && title !== 'EDIT' && otherDetails && (otherDetails.resource === 'InvoiceEntry' || otherDetails.resource === 'ThirdPartyWorkApproval') && initialValue && initialValue._id &&
          <Select.Option key={initialValue && initialValue._id}
                         value={initialValue && initialValue._id}>{initialValue && initialValue.name}</Select.Option> || ''}

          {!this.state.value && otherDetails && (otherDetails.resource === 'ThirdPartyWorkQuotation') && initialValue && initialValue._id &&
          <Select.Option key={initialValue && initialValue._id}
                         value={initialValue && initialValue._id}>{initialValue && initialValue.name}</Select.Option> || ''}

          {!this.state.value && title === 'EDIT' && initialValue &&
          <Select.Option key={initialValue._id} value={initialValue._id}>{initialValue[field]}</Select.Option> || ''}
          {
            this.state.value && filteredSearchData && filteredSearchData.map(item => {
              return <Select.Option key={item._id} value={item._id}>{item[field]}</Select.Option>
            })
          }
        </Select>)
        }
        {
          options && options.master ?
            <MasterModal subMaster={otherDetails.subMaster || false} superMaster={otherDetails.superMaster || false}
                         resource={otherDetails.resource} disableAll={this.props && this.props.disableAll}
                         item={options.ref} title={'CREATE'}/> : ''
        }
        {
          options && options.superMaster ?
            <SuperMasterModal resource={otherDetails.resource} disableAll={this.props && this.props.disableAll}
                              item={options.ref} title={'CREATE'}/> : ''
        }
        {/* For Scan Asset QR Coded */}
        {
          options && options.qr_scan && (!disabled && !this.props.disableAll) ?
            <div>
              <Modal
                title="Scan QR Code"
                visible={this.state.openCamera}
                onCancel={this.openCamera}
                centered
                footer={<Button onClick={this.openCamera}>Close</Button>}
              >
                {
                  this.state.openCamera && <QrReader
                    delay={300}
                    onError={this.handleScanError}
                    onScan={this.handleScan.bind(this)}
                    style={{width: '100%', margin: '0 auto'}}
                    facingMode={'environment'}
                    // onImageLoad={this.onLoad}
                  />
                  // openCamera && <Scanner/>
                }
              </Modal>
              <Button type="primary" disabled={this.state.manualAssetSelect} onClick={this.openCamera}
                      className="gx-mb-0">Scan QR Code</Button>
              <Checkbox checked={this.state.manualAssetSelect} onChange={this.toggleManual}>Manual Search</Checkbox>
            </div> : ''
        }
      </Form.Item>
    );
  }
}

FieldSearchForm.defaultProps = {};

FieldSearchForm.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.node,
  message: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.string,
  model: PropTypes.string,
  initialValue: PropTypes.object,
  fetchRelationshipSearch: PropTypes.func,
  fetchRelationshipSearchData: PropTypes.func,
  customSearch: PropTypes.func,
  searchDataOverride: PropTypes.array,
  minSearchLength: PropTypes.number,
  getFieldDecorator: PropTypes.func,
  setFieldsValue: PropTypes.func,
  searchData: PropTypes.array,
  excludedIds: PropTypes.array,
  formIndex: PropTypes.number
};


const mapStateToProps = ({commonData, assetService}) => {
  return {
    filters: commonData.filters,
    modules: commonData.modules,
    searchData: commonData.relationshipSearch
  };
};

function mapDispatchToProps(dispatch) {
  return {
    fetchRelationshipSearch,
    fetchRelationshipSearchData,
    saveSpareNameInSpareIssues
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(FieldSearchForm);
